import lt from './lt.json';
import en from './en.json';

export default {
  lt,
  en,
};
